import { useTranslations } from 'next-intl'
import { useCallback } from 'react'

import type {
  FirmwareDeploymentStatus,
  FirmwareFailureHandling,
  FirmwareRolloutStrategy,
  FirmwareStationStatus
} from '~/data/types/firmwareDeployments'

// Enum → label formatters for managed firmware rollouts. The input types are
// literal unions, so each template resolves to a literal union of valid keys
// and next-intl's compile-time key checking stays intact.

export function useRolloutStrategyFormatter() {
  const t = useTranslations('data.firmwareDeployments')
  return useCallback((strategy: FirmwareRolloutStrategy) => t(`strategy_${strategy}`), [t])
}

export function useFailureHandlingFormatter() {
  const t = useTranslations('data.firmwareDeployments')
  return useCallback((failureHandling: FirmwareFailureHandling) => t(`failureHandling_${failureHandling}`), [t])
}

export function useDeploymentStatusFormatter() {
  const t = useTranslations('data.firmwareDeployments')
  return useCallback((status: FirmwareDeploymentStatus) => t(`status_${status}`), [t])
}

export function useStationStatusFormatter() {
  const t = useTranslations('data.firmwareDeployments')
  return useCallback((status: FirmwareStationStatus) => t(`stationStatus_${status}`), [t])
}
